<template>
  <j-modal
    :width="700"
    :visible="visible"
    :mask="true"
    :fullscreen="izMobile"
    class="j-super-query-modal"
    style="top: 5%; max-height: 95%"
    okText="签到"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <div slot="title" style="font-weight: bold">学生辅导</div>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-form-model-item label="年级" prop="grade">
        <a-select v-model="form.grade" placeholder="请选择年级" :options="gradeOptions" />
      </a-form-model-item>
      <a-form-model-item label="班级" prop="class">
        <a-select
          v-model="form.class"
          placeholder="请选择班级"
          :options="classOptions"
          :disabled="!form.grade"
        />
      </a-form-model-item>
      <a-form-model-item label="学生" prop="student">
        <a-select
          v-model="form.student"
          placeholder="请选择学生"
          :options="studentOptions"
          :disabled="!form.class"
        />
      </a-form-model-item>
      <a-form-model-item label="内容" prop="content" :wrapper-col="{ span: 19 }">
        <a-input
          v-model="form.content"
          placeholder="请输入内容"
          type="textarea"
          :auto-size="{ minRows: 5, maxRows: 6 }"
        />
      </a-form-model-item>
    </a-form-model>
  </j-modal>
</template>

<script>
import { getAction } from '@api/manage'

export default {
  name: 'StudentCounseModal',
  props: {},
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      detailList: [],
      form: {},
      gradeOptions: [
        { value: '2016', label: '2016' },
        { value: '2017', label: '2017' },
        { value: '2018', label: '2018' },
      ],
      classOptions: [
        { value: '1班', label: '1班' },
        { value: '2班', label: '2班' },
        { value: '3班', label: '3班' },
      ],
      studentOptions: [
        { value: '张三', label: '张三' },
        { value: '李四', label: '李四' },
      ],
      rules: {
        grade: [{ required: true, message: '请选择年级', trigger: 'blur' }],
        class: [{ required: true, message: '请选择班级', trigger: 'blur' }],
        student: [{ required: true, message: '请选择学生', trigger: 'blur' }],
        content: [{ required: true, message: '请选择内容', trigger: 'blur' }],
      },
    }
  },
  computed: {
    izMobile() {
      return this.device === 'mobile'
    },
  },
  methods: {
    show(data) {
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        console.log('验证数据：', valid)
        if (!valid) return
        console.log('提交数据：', this.form)
        this.close()
        this.$emit('ok')
        this.form = {}
      })
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  // justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
  font-size: 13px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
</style>
